import { addLocaleData } from 'react-intl';

import config from '../../constants/config';
import { STORAGE_KEY } from '../../constants/generic';
import { getReactLocale } from './helpers';

// noinspection JSUnusedGlobalSymbols
export function setLanguage(locale) {
  if (!locale) locale = config.getDefaultLocale();

  addLocaleData(require('react-intl/locale-data/' + getReactLocale(locale)));

  window.localStorage.setItem(STORAGE_KEY.LOCALE, locale);

  return {
    type: 'SET_LANGUAGE',
    payload: {
      locale: locale,
      messages: require('../../i18n/' + locale)
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/i18nActions/index.js
 **/